import classnames from "classnames";
import React from "react";

import { SalesIncentiveType } from "@utils/enums";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { ProductRibbonLabel } from "@components/Product/Layout/ProductLabel/productRibbonLabel.component";

import { PromoLabel } from "lib/@types/service/shared";

type Props = {
    promoLabel?: PromoLabel;
    className?: string;
};

const PromotionRibbon = ({ promoLabel, className }: Props) => {
    const { t } = useGranite();

    if (!promoLabel) {
        return null;
    }

    return (
        <div className={classnames("mr-2 position-relative", className)}>
            <ProductRibbonLabel
                text={t(`promotionLabel.${promoLabel.promoLabeLType}`)}
                size={
                    [
                        SalesIncentiveType.GratisTransport,
                        SalesIncentiveType.EveryDayLowPrice,
                    ].some(si => si === promoLabel.salesIncentiveType)
                        ? "xs"
                        : "sm"
                }
                secondary={promoLabel.formattedPromotionValue}
            />
        </div>
    );
};

export { PromotionRibbon };
